import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useAssistenciaTecnicaListaFilters
 */

type State = {
  idCliente: number[] | null;
  cliente: string | null;
  centroCustos: number[] | null;
  local: string | null;
  dataAberturaDe: Date | null;
  dataAberturaAte: Date | null;
  tipo: number | null;
  dataEncerramentoDe: Date | null;
  dataEncerramentoAte: Date | null;
  codigo: number | null;
  procedente: number | null;
  categorias: number[] | null;
  resolvido: number | null;
  prioridade: number | null;
  nroChamado: string | null;
  status: number | null;
};

type Actions = {
};

export const initialAssistenciaTecnicaListaFiltersState: State = {
  idCliente: null,
  cliente: null,
  centroCustos: null,
  local: null,
  dataAberturaDe: null,
  dataAberturaAte: null,
  tipo: 2,
  dataEncerramentoDe: null,
  dataEncerramentoAte: null,
  codigo: null,
  procedente: 3,
  categorias: null,
  resolvido: 4,
  prioridade: 3,
  nroChamado: null,
  status: 1,
};

export const useAssistenciaTecnicaListaFilters = create<State & Actions>((set) => ({
  ...initialAssistenciaTecnicaListaFiltersState,
}));

